import { AnimatedNumber } from 'shared/components/motion/AnimatedNumber';

interface StatTileProps {
  label: string;
  value: string;
}

export function StatTile({ label, value }: StatTileProps) {
  return (
    <div className="h-full rounded-2xl border border-border/40 bg-surface p-4 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-card-hover">
      <p className="text-xs font-semibold uppercase tracking-wide text-primary">{label}</p>
      <AnimatedNumber value={value} className="mt-1 block text-xl font-bold text-ink" />
    </div>
  );
}
